import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=3ff4e395&"
import script from "./NavItem.vue?vue&type=script&lang=ts&"
export * from "./NavItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports